// extracted by css-extract-rspack-plugin
export default {"quote":"content-editor-plugin-quote-Quote-quote-1ec6ec6a","icon":"content-editor-plugin-quote-Quote-icon-32e7ce75"};